module.exports = __webpack_public_path__ + "ptc_nakagawa_P1.bd002b68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_P1.jpg
// module id = pMpv
// module chunks = 0